import { HttpService } from '@maia/httpClient';
import { BaseService } from '@maia/feature-utils';
import { ConfigService } from '@maia/config';
import { ITaskEntity } from '../../shared';
import {
  TaskCreateDto,
  TaskPostMessageDto,
  TaskPutOptionsDto,
} from '../../dtos/task.dto';

export class TaskService extends BaseService {
  constructor(httpService: HttpService, configService: ConfigService) {
    super(httpService, configService);
  }

  public async findMany(path: string, search: Record<string, unknown>) {
    return await this.getMany<ITaskEntity>(path, search, 'tasks');
  }

  public async find(path: string) {
    return this.get<ITaskEntity>(path, 'tasks');
  }

  public async sendMessage<
    T extends ConstructorParameters<typeof TaskPostMessageDto>[number],
  >(body: T & { customerGuid: string; taskGuid: string }) {
    return this.post<ITaskEntity, TaskPostMessageDto>(
      `customers/${body.customerGuid}/tasks/${body.taskGuid}/messages`,
      new TaskPostMessageDto(body),
      'tasks',
    );
  }

  public async updateOptions<
    T extends ConstructorParameters<typeof TaskPutOptionsDto>[number],
  >(body: T & { customerGuid: string; taskGuid: string }) {
    return this.put<{ task_guid: 'string' }, TaskPutOptionsDto>(
      `customers/${body.customerGuid}/tasks/${body.taskGuid}`,
      new TaskPutOptionsDto(body),
      'tasks',
    );
  }

  public async create<
    T extends ConstructorParameters<typeof TaskCreateDto>[number],
  >(body: T & { customerGuid: string }) {
    return this.post<{ task_guid: string }, TaskCreateDto>(
      `customers/${body.customerGuid}/tasks`,
      new TaskCreateDto(body),
      'tasks',
    );
  }
}
